import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { notNil } from '@robocorp/robocloud-shared-utils';
import { useIndexedProcessRunsQuery } from '~/queries';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectProcessRun: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters,
  ...props
}) => {
  const { t } = useTranslation();

  const { data: indexedProcessRuns, isInitialLoading: isLoadingProcessRuns } =
    useIndexedProcessRunsQuery({
      processId: pathParameters.process_id,
      workspaceId: String(pathParameters.workspace_id),
      size: 30,
      options: {
        enabled: notNil(pathParameters.process_id),
      },
    });

  const processRunItems = useMemo(() => {
    return indexedProcessRuns?.processRuns
      ? indexedProcessRuns.processRuns.map(({ id, processName, runNo }) => {
          return { label: `${processName} #${runNo}`, value: id };
        })
      : [];
  }, [indexedProcessRuns]);

  return (
    <ApiHelperSelectInput
      label={t('chooseProcessRun')}
      items={processRunItems}
      onChange={(value) => setValue('process_run_id', value)}
      loading={isLoadingProcessRuns}
      value={value}
      noItemsFound={t('noRunsForProcess')}
      {...props}
    />
  );
};
